import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { MediaEffects } from './media.effects';
import { mediaFeatureKey, mediaReducer } from './media.reducer';

export const MediaFeatureProviders = [
  provideState(mediaFeatureKey, mediaReducer),
  provideEffects(MediaEffects),
];
